import { API, apiCall, NEW_BE_API } from "../../utils/APIFunctions";

export function oldGetCompanySettings(companyId) {
  return apiCall(`${API}/companies/${companyId}/settings`,"get");
}
export function newGetCompanySettings(companyId) {
  return apiCall(`${NEW_BE_API}/api/n1/companies/${companyId}/settings`,"get");
}

export function oldUpdateCompanySettings(params) {
  return apiCall(`${API}/companies/${params.companyId}/settings`,"put", JSON.stringify(params));
}
export function newUpdateCompanySettings(params) {
  return apiCall(`${NEW_BE_API}/api/n1/companies/${params.companyId}/settings`,"put", JSON.stringify(params));
}
